import React from 'react';

function TableCell({ value, maxValue, minValue }) {
    function getColorCode(value) {
        if (value === null) {
            return `rgb(255, 255, 255)`;
        }
        // Ensure the value is between -1 and 1
        value = Math.min(maxValue, Math.max(minValue, value));

        // Calculate the red and green components
        const red = Math.round(255 * (maxValue - value) / (maxValue - minValue));
        const green = Math.round(255 * (value - minValue) / (maxValue - minValue));

        // Construct the RGB color code
        const colorCode = `rgb(${red}, ${green}, 0)`;

        return colorCode;
    }

    return (
        <td
            style={{ backgroundColor: getColorCode(value) }}
        >
            {value}
        </td>
    );
}


export default TableCell;